import { createFileRoute } from '@tanstack/react-router';
import SessionsPage from '@features/admin/sessions/SessionsPage.tsx';
import { useAdminSessionStore } from '@features/admin/sessions/useAdminSessionStore.ts';

export const Route = createFileRoute('/admin/sessions/')({
  component: RouteComponent,
  beforeLoad: () => {
    useAdminSessionStore.getState().loadSessions();
  },
});

function RouteComponent() {
  return <SessionsPage />;
}
